export enum ButtonType {
  Default,
  Success,
  Warning,
  Error,
  Flag
}
